import { AxiosInstance } from 'axios';

import { ExpandPromiseResponse } from '@sv-support-sdk/shared-types/src/common/utils';
import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';

interface SendChatRequest {
  user_id?: string;
  user_name?: string;
  company_id?: number;
  company?: string | number;
  browser: string;
  uuid?: string;
  fp?: string;
  referer?: string;
  messageUuid?: string;
  welcome_message?: string;
  init_message?: string;
}

interface SendChatResponse {
  success?: boolean;
  createdAt: string;
  userName: string;
  initMessage?: IMessage;
  chatId: number;
  uuid?: string;
  messages: IMessage[];
}

interface CloseChatRequest {
  user_id?: string;
  chat_id: number;
  rate?: string;
  comment?: string;
  hash?: string;
}

interface CloseChatResponse {
  withCsat: boolean;
}

interface ChatLocationRequest {
  hash: string;
  url: string;
}

export default (api: AxiosInstance) => ({
  sendChatRequest: <T>(data: SendChatRequest): ExpandPromiseResponse<SendChatResponse, T> => api.post('new', data),
  closeChat: <T>(data: CloseChatRequest): ExpandPromiseResponse<CloseChatResponse, T> =>
    api.post('new/close', data),
  sendChatLocation: (chatId: number, data: ChatLocationRequest) =>
    api.post(`${chatId}/location`, data),
});
